import { useState, useEffect } from "react";

import { getBlogPosts } from "../contentful";

export default function usePosts(category) {
  const [posts, setPosts] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; // Prevent setting state if the component unmounts
    setLoading(true);

    getBlogPosts(category).then((blogPosts) => {
      if (isMounted) {
        setPosts(blogPosts);
        setLoading(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [category]);

  return [posts, isLoading];
}
